import Container from '@mui/material/Container';
import React from 'react';

import { useTranslation } from "react-i18next";

 function Help() {
   const { t } = useTranslation("common");
   return (
     <div>
     <Container maxWidth="sm">
      <br/>
      <br/>
      {t('help.source')}<a href="mailto:ksk@ksk-dev.com">ksk@ksk-dev.com</a>
      <br/>
      {t('version')}
    </Container>
  </div>
  );
 }
export default function App() {
  return (
      <Help />
  );
}

//https://www.codeandweb.com/babeledit/tutorials/how-to-translate-your-react-app-with-react-i18next